// import { Component, Input } from '@angular/core';

// @Component({
//   selector: '[app-menu]',
//   templateUrl: './menu.component.html'
// })

// export class MenuComponent {

//   @Input() items!: any[];
//   @Input() idparent: string = 'MainMenu';

//   constructor() {

//   }

// }


import { Component, Input, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { Offcanvas } from 'bootstrap';

@Component({
  selector: '[app-menu]',
  templateUrl: './menu.component.html'
})
export class MenuComponent implements AfterViewInit {

  @Input() items!: any[];
  @Input() idparent: string = 'MainMenu';

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    this.updateActiveParent();

    // Observar cambios en las clases de los enlaces
    const observer = new MutationObserver(() => this.updateActiveParent());
    this.el.nativeElement.querySelectorAll('.btn-toggle-nav a').forEach(link => {
      observer.observe(link, { attributes: true, attributeFilter: ['class'] });
    });
  }

  private updateActiveParent() {
    const menuElements = this.el.nativeElement.querySelectorAll('li');

    menuElements.forEach((li: HTMLElement) => {
      const btnToggle = li.querySelector('.btn-toggle');
      const hasActiveChild = li.querySelector('.btn-toggle-nav a.active');

      if (btnToggle) {
        if (hasActiveChild) {
          this.renderer.addClass(btnToggle, 'active-parent');
        } else {
          this.renderer.removeClass(btnToggle, 'active-parent');
        }
      }
    });
  }

  closeOffcanvas() {
    const offcanvasElement = document.getElementById('offcanvasScrolling');
    if (offcanvasElement) {
      const offcanvasInstance = Offcanvas.getInstance(offcanvasElement) || new Offcanvas(offcanvasElement);
      offcanvasInstance.hide();
    }
  }


}
